// extracted by mini-css-extract-plugin
export var loading = "styles-module--loading--mcZu8";
export var container = "styles-module--container--2RYa3";